"use strict";

window.FoG = window.FoG || {};

window.FoG.Analytics = (function($) {
  function init() {
    if (!window.ga) { return; }
    
    $('body').on('click', 'a[data-banner-slug]', function(e) {
      if (!this || !this.dataset || !this.dataset.bannerSlug) { return; }
      
      var bannerSlug = this.dataset.bannerSlug;
      
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'CTA',
        eventAction: 'click',
        eventLabel: 'Banner-' + bannerSlug
      });
    });
  }
  
  $(init);
  
  return {};
})(jQuery);